import { Typography } from '@mui/material';
import { Field } from 'types/api/Tenant/AROKMS/DisplayTableTypes';

export function getReadOnlyFieldMessage(field: Field) {
  if (field.serverEvaluated) return 'This field is updated automatically and cannot be edited.';
  if (field.procedureReadOnly) return 'This field is read-only for this procedure.';
  return 'This field cannot be edited.';
}

export function ReadOnlyFieldNotice({ field }: { field: Field }) {
  if (!field.disabled) return null;

  return (
    <Typography
      component='p'
      width='65%'
      ml='40%'
      mt={0.25}
      mb={-2}
      fontSize={11}
      lineHeight={1.4}
      fontStyle='italic'
      color='text.secondary'
    >
      {getReadOnlyFieldMessage(field)}
    </Typography>
  );
}
